// Global UI preference: whether the editor's live preview pane is shown.
// Best-effort localStorage, mirroring draftStorage's degrade-silently writes.

const KEY = 'nd-admin-preview-open';

// Default to shown: only an explicit '0' means collapsed, so an unset or
// unreadable value gives the author the preview.
export function loadPreviewOpen(): boolean {
  try {
    return localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
}

export function savePreviewOpen(open: boolean): void {
  try {
    localStorage.setItem(KEY, open ? '1' : '0');
  } catch {
    // storage unavailable (private mode / quota) — preference silently degrades
  }
}
